export default __webpack_public_path__ + "static/media/geometry-artwork-10.c7a123c0.webp";